<!-- app-subdomain-creators/src/Components/NewsfeedDeleteCommentReplyConfirmModal.vue -->
<template>
  <teleport to="body">
    <Transition
      enter-active-class="ease-out duration-150"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-150"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="isOpen"
        class="fixed inset-0 bg-zinc-100 bg-opacity-[0.80] flex justify-center items-center py-2 z-[99999]"
        @click.self="handleCancel"
      >
        <div
          class="bg-[#fff] relative rounded-xl max-w-[550px] w-full mx-auto border-[1px] pt-5 pb-4 border-zinc-200 shadow-lg"
          @click.stop
        >
          <!-- close button -->
          <button
            @click="handleCancel"
            class="text-gray-800 hover:text-gray-900 absolute top-3 right-4 rounded-full bg-zinc-200 hover:bg-zinc-300 p-1"
          >
            <XMarkIcon class="w-6 h-6 font-bold" />
          </button>

          <!-- header -->
          <div class="px-6 pb-3 w-full border-b border-zinc-300">
            <h3 class="text-[19px] font-semibold text-center text-zinc-950">
              {{ title }}
            </h3>
          </div>

          <!-- body text -->
          <div class="px-6 pb-4 pt-2">
            <p class="text-sm text-zinc-800 font-light">
              {{ message }}
            </p>
            <p
              v-if="errorMessage"
              class="mt-3 text-sm text-red-600 font-medium"
            >
              {{ errorMessage }}
            </p>
          </div>

          <!-- buttons -->
          <div class="px-5 pt-1 pb-1 flex justify-end gap-2">
            <button
              type="button"
              class="px-4 py-2 rounded-lg text-sm font-medium text-zinc-700 hover:bg-zinc-100"
              @click="handleCancel"
              :disabled="isSubmitting"
            >
              Cancel
            </button>

            <button
              type="button"
              class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-[#2D8CFF] hover:bg-[#1f7aeb] disabled:bg-[#9bbef3] disabled:cursor-not-allowed w-32"
              @click="handleConfirm"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? 'Deleting...' : 'Delete' }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </teleport>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  // Comment vs reply wording
  title: {
    type: String,
    default: 'Delete Comment?',
  },
  message: {
    type: String,
    default: 'Are you sure you want to delete this comment?',
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['cancel', 'confirm']);

const handleCancel = () => {
  if (props.isSubmitting) return;
  emit('cancel');
};

const handleConfirm = () => {
  if (props.isSubmitting) return;
  emit('confirm');
};
</script>

